var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-transition',[_c('v-row',{staticClass:"text-center h-60-vh align-center"},[_c('v-col',[_c('v-progress-circular',{staticClass:"mr-3",attrs:{"indeterminate":"","color":"primary"}}),_c('span',{staticClass:"body-2",domProps:{"textContent":_vm._s(_vm.text)}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }